import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "drugName", "din"]
  static values = { url: String }

  connect() {
    this.timeout = null
  }

  preventSubmit(event) {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }

  search() {
    clearTimeout(this.timeout)

    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.timeout = setTimeout(() => {
      this.fetchResults(query)
    }, 200)
  }

  async fetchResults(query) {
    try {
      const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`)
      const medications = await response.json()

      if (medications.length > 0) {
        this.showResults(medications)
      } else {
        this.hideResults()
      }
    } catch (error) {
      console.error("Error fetching medications:", error)
      this.hideResults()
    }
  }

  showResults(medications) {
    this.resultsTarget.innerHTML = medications.map(med => `
      <button type="button"
              class="w-full text-left px-3 py-2 hover:bg-slate-100 cursor-pointer border-b border-slate-100 last:border-b-0"
              data-action="click->medication-search#select"
              data-name="${this.escapeHtml(med.name)}"
              data-din="${this.escapeHtml(med.din)}">
        <div class="font-medium text-sm text-slate-900">${this.escapeHtml(med.name)}</div>
        <div class="text-xs text-slate-500">DIN: ${this.escapeHtml(med.din)} &middot; ${this.escapeHtml(med.company_name || "")}</div>
        ${this.formatIngredients(med.active_ingredients)}
      </button>
    `).join("")

    this.resultsTarget.classList.remove("hidden")
  }

  formatIngredients(ingredients) {
    if (!ingredients || ingredients.length === 0) return ""

    const list = ingredients.map(ing => {
      const parts = [ing.name]
      if (ing.strength) {
        parts.push(ing.strength + (ing.unit || ""))
      }
      return this.escapeHtml(parts.join(" "))
    }).join(", ")

    return `<div class="text-xs text-slate-400 mt-0.5">${list}</div>`
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden")
    this.resultsTarget.innerHTML = ""
  }

  select(event) {
    event.preventDefault()
    const button = event.currentTarget
    const name = button.dataset.name
    const din = button.dataset.din

    this.drugNameTarget.value = name
    this.dinTarget.value = din
    this.inputTarget.value = ""
    this.hideResults()
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
